module.exports = __webpack_public_path__ + "img/logo-m.75403673.png";